module.exports = __webpack_public_path__ + "static/media/Sharing Guidelines.402e53c5.svg";